var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 7.28405H17.03C16.77 7.28405 16.49 7.54419 16.44 7.60422C16.25 7.79433 16.25 8.04447 16.25 8.19455C16.25 8.32462 16.26 8.4547 16.28 8.59478C16.3 8.73485 16.31 8.87493 16.31 9.03502C16.31 13.0573 13.03 16.3291 9 16.3291C4.97 16.3291 1.69 13.0472 1.69 9.02501C1.69 5.00278 4.97 1.74097 9 1.74097C10.15 1.74097 11.27 2.00111 12.26 2.48138C12.38 2.58143 12.55 2.58143 12.63 2.58143C12.96 2.58143 13.22 2.41134 13.39 2.09116C13.48 1.83102 13.48 1.66092 13.4 1.42079C13.36 1.33074 13.2 1.03057 12.98 0.920511C11.68 0.310172 10.35 0 9.01 0C4.04 0.0600334 0 4.11228 0 9.02501C0 13.9377 4.04 18 9 18C13.96 18 18 13.9778 18 9.02501C18 8.69483 18 8.36465 17.93 8.01445C17.93 7.64425 17.54 7.27404 17.09 7.27404V7.28405Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87 7.53419C6.7 7.36409 6.51 7.28405 6.28 7.28405C6.05 7.28405 5.86 7.36409 5.69 7.53419C5.52 7.70428 5.44 7.89439 5.44 8.12451C5.44 8.35464 5.52 8.54475 5.69 8.71484L8.41 11.4263C8.58 11.5964 8.77 11.6765 9 11.6765C9.23 11.6765 9.42 11.5964 9.59 11.4263L17.75 3.29183C17.91 3.13174 18 2.92162 18 2.7015C18 2.48138 17.91 2.27126 17.75 2.11117C17.58 1.94108 17.39 1.86103 17.16 1.86103C16.93 1.86103 16.74 1.94108 16.57 2.11117L9 9.65536L6.87 7.53419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast-success.d0d92d7edcc56a1d00c0cba451683f2f.svg";
export { ForwardRef as ReactComponent };